import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { OpenInNewTabModule } from '../../directives/open-in-new-tab/open-in-new-tab.module';
import { IconModule } from '../icon/icon.module';
import { LinkComponent } from './link.component';

@NgModule({
  imports: [CommonModule, IconModule, OpenInNewTabModule, RouterModule],
  exports: [LinkComponent],
  declarations: [LinkComponent],
})
export class LinkModule {}
